export { LegalWrapper } from './legal-wrapper';
export type {
  LegalWrapperProps,
  LegalWrapperData,
  LegalWrapperOptions,
} from './legal-wrapper';
export { LegalWrapperInterface } from './legal-wrapper.interface';
